import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router';
import { REQUEST_SCHOOL_EDIT, fetchSchoolEdit } from '@/modules/User';
import Centrify from 'sama_global/components/Centrify';
import { Box } from 'UIKit/Grid';
import Panel from 'sama_global/components/Panel';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import { useLoadbar } from 'sama_global/utils/hooks/loadbar';
import Form from 'sama_global/components/Form';
import { required, minLength4, universalPhoneNumber } from '@/utils/Validate';
import { cleaRequest } from '@/modules/Requests';

const fields = [
  {
    name: 'email',
    locale: 'EMAIL',
    disabled: true,
  },
  {
    name: 'password',
    locale: 'PASSWORD',
    validate: [minLength4],
  },
  {
    name: 'name_en',
    locale: 'NAME',
    validate: [required],
  },
  {
    name: 'surname_en',
    locale: 'SURNAME',
    validate: [required],
  },
  {
    name: 'phone',
    locale: 'PHONE',
    validate: [universalPhoneNumber],
  },
  {
    name: 'school[name]',
    locale: 'COUNTRY',
    validate: [required],
  },
];

const Edit = ({ onEdit, requests, clearRequest }) => {
  const request = requests[REQUEST_SCHOOL_EDIT];

  useSnackbarListener(request?.errorMessage);
  useSnackbarListener(request?.success ? 'SAVED' : '', 'success');
  useLoadbar(REQUEST_SCHOOL_EDIT);

  // eslint-disable-next-line camelcase
  const { _id, email, name_en, surname_en, birthday, phone, school } =
    useLocation().state || {};

  const handleSubmit = formData => {
    onEdit(_id, formData);
  };

  useEffect(() => () => clearRequest(REQUEST_SCHOOL_EDIT), []);

  return (
    <Centrify>
      <Box py={5} w={1} style={{ maxWidth: '620px', margin: 'auto' }}>
        <Panel>
          <Form
            title="EDIT_DELEGATE"
            initialValues={{
              email,
              name_en,
              surname_en,
              birthday,
              phone,
              school,
            }}
            fields={fields}
            onSubmit={handleSubmit}
            form="delegates_edit"
            fit
          />
        </Panel>
      </Box>
    </Centrify>
  );
};

Edit.propTypes = {
  requests: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  clearRequest: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  onEdit(id, formData) {
    dispatch(fetchSchoolEdit(id, formData));
  },
  clearRequest(name) {
    dispatch(cleaRequest(name));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
